import { render } from "./Generator.vue?vue&type=template&id=2aab6e7f"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"

import "./Generator.vue?vue&type=style&index=0&id=2aab6e7f&lang=scss"
script.render = render

export default script